import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const EnablersDataGrid = ({ searchQuery, onEdit, onDelete, selectedItems, onSelectionChange }) => {
  const [sortField, setSortField] = useState('company_name');
  const [sortDirection, setSortDirection] = useState('asc');

  // Coal trading enablers data
  const enablersData = [
    {
      id: 1,
      service_category: 'Survey & Inspection',
      company_name: 'Queensland Ship Surveyors',
      contact_person: 'John Smith',
      phone: '+61 7 3221 4567',
      email: 'john.smith@qss.com.au',
      address: 'Brisbane, QLD',
      services: 'Marine surveys, cargo inspection',
      status: 'Active'
    },
    {
      id: 2,
      service_category: 'Survey & Inspection',
      company_name: 'Maritime Survey Australia',
      contact_person: 'Sarah Johnson',
      phone: '+61 2 9876 5432',
      email: 'sarah.johnson@msa.com.au',
      address: 'Sydney, NSW',
      services: 'Vessel surveys, quality inspection',
      status: 'Active'
    },
    {
      id: 3,
      service_category: 'Lab Analysis',
      company_name: 'ALS Coal Testing',
      contact_person: 'Michael Brown',
      phone: '+61 7 3212 5000',
      email: 'michael.brown@als.com',
      address: 'Brisbane, QLD',
      services: 'Coal quality analysis, lab testing',
      status: 'Active'
    },
    {
      id: 4,
      service_category: 'Quality Inspection',
      company_name: 'Intertek',
      contact_person: 'Emma Wilson',
      phone: '+61 2 9900 1234',
      email: 'emma.wilson@intertek.com',
      address: 'Newcastle, NSW',
      services: 'Quality assurance, cargo inspection',
      status: 'Active'
    },
    {
      id: 5,
      service_category: 'Testing & Certification',
      company_name: 'SGS Australia',
      contact_person: 'David Lee',
      phone: '+61 7 3259 6666',
      email: 'david.lee@sgs.com',
      address: 'Brisbane, QLD',
      services: 'Testing, certification, verification',
      status: 'Active'
    },
    {
      id: 6,
      service_category: 'Testing & Certification',
      company_name: 'Bureau Veritas',
      contact_person: 'Lisa Anderson',
      phone: '+61 2 8484 8000',
      email: 'lisa.anderson@bureauveritas.com',
      address: 'Sydney, NSW',
      services: 'Certification, inspection services',
      status: 'Active'
    },
    {
      id: 7,
      service_category: 'Port Agency Services',
      company_name: 'Wilhelmsen',
      contact_person: 'Robert Taylor',
      phone: '+61 2 9563 9999',
      email: 'robert.taylor@wilhelmsen.com',
      address: 'Sydney, NSW',
      services: 'Ship agency, port services',
      status: 'Active'
    },
    {
      id: 8,
      service_category: 'Terminal Services',
      company_name: 'Dalrymple Bay Coal Terminal',
      contact_person: 'Jennifer White',
      phone: '+61 7 4999 2000',
      email: 'jennifer.white@dbct.com.au',
      address: 'Mackay, QLD',
      services: 'Coal terminal operations, loading',
      status: 'Active'
    },
    {
      id: 9,
      service_category: 'Terminal Services',
      company_name: 'Port Waratah Coal Services',
      contact_person: 'Thomas Martin',
      phone: '+61 2 4907 2000',
      email: 'thomas.martin@pwcs.com.au',
      address: 'Newcastle, NSW',
      services: 'Coal handling, terminal services',
      status: 'Active'
    },
    {
      id: 10,
      service_category: 'Port Authorities',
      company_name: 'Port of Newcastle',
      contact_person: 'Amanda Garcia',
      phone: '+61 2 4908 8200',
      email: 'amanda.garcia@portofnewcastle.com.au',
      address: 'Newcastle, NSW',
      services: 'Port management, infrastructure',
      status: 'Active'
    },
    {
      id: 11,
      service_category: 'Port Authorities',
      company_name: 'Gladstone Ports Corporation',
      contact_person: 'Chris Rodriguez',
      phone: '+61 7 4976 1333',
      email: 'chris.rodriguez@gpc.qld.gov.au',
      address: 'Gladstone, QLD',
      services: 'Port operations, trade facilitation',
      status: 'Active'
    },
    {
      id: 12,
      service_category: 'Freight & Logistics',
      company_name: 'Aurizon',
      contact_person: 'Patricia Martinez',
      phone: '+61 7 3019 5000',
      email: 'patricia.martinez@aurizon.com.au',
      address: 'Brisbane, QLD',
      services: 'Rail freight, coal haulage',
      status: 'Active'
    },
    {
      id: 13,
      service_category: 'Insurance Providers',
      company_name: 'Lockton',
      contact_person: 'Kevin Thompson',
      phone: '+61 2 9956 8000',
      email: 'kevin.thompson@lockton.com',
      address: 'Sydney, NSW',
      services: 'Marine insurance, cargo coverage',
      status: 'Active'
    },
    {
      id: 14,
      service_category: 'Insurance Providers',
      company_name: 'Aon Australia',
      contact_person: 'Michelle Harris',
      phone: '+61 2 9253 7000',
      email: 'michelle.harris@aon.com',
      address: 'Sydney, NSW',
      services: 'Insurance brokerage, risk management',
      status: 'Active'
    },
    {
      id: 15,
      service_category: 'Environmental Compliance',
      company_name: 'Worley',
      contact_person: 'Daniel Clark',
      phone: '+61 2 8923 6866',
      email: 'daniel.clark@worley.com',
      address: 'Sydney, NSW',
      services: 'Environmental consulting, compliance',
      status: 'Active'
    }
  ];

  const filteredEnablers = enablersData?.filter(enabler =>
    enabler?.company_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    enabler?.service_category?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    enabler?.contact_person?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    enabler?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const sortedEnablers = [...filteredEnablers]?.sort((a, b) => {
    const aValue = a?.[sortField] || '';
    const bValue = b?.[sortField] || '';
    
    if (sortDirection === 'asc') {
      return aValue?.toString()?.localeCompare(bValue?.toString());
    }
    return bValue?.toString()?.localeCompare(aValue?.toString());
  });

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      onSelectionChange(sortedEnablers?.map(e => e?.id));
    } else {
      onSelectionChange([]);
    }
  };

  const handleSelectItem = (id, checked) => {
    if (checked) {
      onSelectionChange([...selectedItems, id]);
    } else {
      onSelectionChange(selectedItems?.filter(item => item !== id));
    }
  };

  const getStatusColor = (status) => {
    return status === 'Active' ? 'text-success' : 'text-muted-foreground';
  };

  const getCategoryColor = (category) => {
    const colors = {
      'Survey & Inspection': 'bg-blue-100 text-blue-800',
      'Lab Analysis': 'bg-purple-100 text-purple-800',
      'Quality Inspection': 'bg-green-100 text-green-800',
      'Testing & Certification': 'bg-orange-100 text-orange-800',
      'Port Agency Services': 'bg-cyan-100 text-cyan-800',
      'Terminal Services': 'bg-indigo-100 text-indigo-800',
      'Port Authorities': 'bg-pink-100 text-pink-800',
      'Freight & Logistics': 'bg-yellow-100 text-yellow-800',
      'Insurance Providers': 'bg-red-100 text-red-800',
      'Environmental Compliance': 'bg-teal-100 text-teal-800'
    };
    return colors?.[category] || 'bg-gray-100 text-gray-800';
  };

  const SortIcon = ({ field }) => {
    if (sortField !== field) return <Icon name="ChevronsUpDown" size={14} className="text-muted-foreground" />;
    return sortDirection === 'asc' ? 
      <Icon name="ChevronUp" size={14} className="text-primary" /> : 
      <Icon name="ChevronDown" size={14} className="text-primary" />;
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-muted/50 border-b border-border">
          <tr>
            <th className="px-6 py-3 text-left w-12">
              <Checkbox
                checked={selectedItems?.length === sortedEnablers?.length && sortedEnablers?.length > 0}
                onCheckedChange={handleSelectAll}
              />
            </th>
            <th className="px-6 py-3 text-left">
              <button
                onClick={() => handleSort('service_category')}
                className="flex items-center gap-2 font-medium text-sm text-foreground hover:text-primary transition-colors"
              >
                Service Category
                <SortIcon field="service_category" />
              </button>
            </th>
            <th className="px-6 py-3 text-left">
              <button
                onClick={() => handleSort('company_name')}
                className="flex items-center gap-2 font-medium text-sm text-foreground hover:text-primary transition-colors"
              >
                Company Name
                <SortIcon field="company_name" />
              </button>
            </th>
            <th className="px-6 py-3 text-left">
              <button
                onClick={() => handleSort('contact_person')}
                className="flex items-center gap-2 font-medium text-sm text-foreground hover:text-primary transition-colors"
              >
                Contact Person
                <SortIcon field="contact_person" />
              </button>
            </th>
            <th className="px-6 py-3 text-left">
              <span className="font-medium text-sm text-foreground">Contact Details</span>
            </th>
            <th className="px-6 py-3 text-left">
              <span className="font-medium text-sm text-foreground">Services</span>
            </th>
            <th className="px-6 py-3 text-left">
              <button
                onClick={() => handleSort('status')}
                className="flex items-center gap-2 font-medium text-sm text-foreground hover:text-primary transition-colors"
              >
                Status
                <SortIcon field="status" />
              </button>
            </th>
            <th className="px-6 py-3 text-right">
              <span className="font-medium text-sm text-foreground">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {sortedEnablers?.length === 0 ? (
            <tr>
              <td colSpan={8} className="px-6 py-12 text-center">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
                    <Icon name="Search" size={24} className="text-muted-foreground" />
                  </div>
                  <div>
                    <p className="text-lg font-medium text-foreground">No enablers found</p>
                    <p className="text-sm text-muted-foreground mt-1">
                      Try adjusting your search criteria or add a new enabler
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            sortedEnablers?.map((enabler) => (
              <tr
                key={enabler?.id}
                className="hover:bg-muted/30 transition-colors"
              >
                <td className="px-6 py-4">
                  <Checkbox
                    checked={selectedItems?.includes(enabler?.id)}
                    onCheckedChange={(checked) => handleSelectItem(enabler?.id, checked)}
                  />
                </td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCategoryColor(enabler?.service_category)}`}>
                    {enabler?.service_category}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Icon name="Building2" size={18} className="text-primary" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground">{enabler?.company_name}</p>
                      <p className="text-xs text-muted-foreground">{enabler?.address}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <p className="text-sm text-foreground">{enabler?.contact_person}</p>
                </td>
                <td className="px-6 py-4">
                  <div className="space-y-1">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Icon name="Phone" size={14} />
                      <span>{enabler?.phone}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Icon name="Mail" size={14} />
                      <span>{enabler?.email}</span>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <p className="text-sm text-muted-foreground max-w-xs">{enabler?.services}</p>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full ${enabler?.status === 'Active' ? 'bg-success' : 'bg-muted-foreground'}`} />
                    <span className={`text-sm font-medium ${getStatusColor(enabler?.status)}`}>
                      {enabler?.status}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center justify-end gap-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Edit"
                      onClick={() => onEdit?.(enabler)}
                      className="text-muted-foreground hover:text-primary"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Trash2"
                      onClick={() => onDelete?.(enabler?.id)}
                      className="text-muted-foreground hover:text-destructive"
                    />
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EnablersDataGrid;